import { Box } from "@mui/material";
import React from "react";
import NotificationsView from "../views/Notifications/NotificationsView";
import PageTitle from "../base/PageTitle";

interface Props {}

const NotificationsPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="Notification Setup" />
      <NotificationsView />
    </Box>
  );
};

export default NotificationsPage;
